var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("ul", { staticClass: "list-group list-group-flush" }, [
      _c("li", { staticClass: "list-group-item" }, [
        _c(
          "div",
          { staticClass: "contenedor-contacts" },
          [
            _c(
              "b-row",
              { staticClass: "align-items-center" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "d-lg-block d-none my-auto",
                    attrs: { cols: "1" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "image-cropper-sm" },
                      [
                        _c("b-skeleton", {
                          attrs: {
                            type: "avatar",
                            width: "100%",
                            height: "100%",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "my-auto",
                    attrs: { cols: "12", sm: "7", md: "3", lg: "3" },
                  },
                  [_c("b-skeleton", { attrs: { width: "8rem" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "my-auto d-lg-block d-md-none d-block",
                    attrs: { cols: "12", sm: "5", lg: "2" },
                  },
                  [_c("b-skeleton", { attrs: { width: "8rem" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "my-auto",
                    attrs: { cols: "12", sm: "7", md: "3", lg: "2" },
                  },
                  [_c("b-skeleton", { attrs: { width: "8rem" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "my-auto",
                    attrs: { cols: "12", sm: "5", md: "3", lg: "2" },
                  },
                  [_c("b-skeleton", { attrs: { width: "8rem" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass:
                      "col text-sm-center text-md-left mt-sm-5 mt-4 mt-md-0",
                  },
                  [
                    _c("b-skeleton", {
                      attrs: { width: "6rem", height: "2rem" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }